import * as Icon from 'react-feather';
import { colorGray } from '@atlas-frontend/design-tokens';
import { TableOperationButton } from '../TableOperationButton';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './CreateTableRowButton.translations.json';
import { ButtonProps } from 'antd';
import { useFocusTableRowField } from './useFocusTableRowField';

const { addTranslations, useTranslation } = i18nNsFactory(
  'create-table-row-button',
);
addTranslations(translations);

export interface CreateTableRowButtonProps<RowData extends Record<string, any>>
  extends Omit<ButtonProps, 'id'> {
  id?: string;
  defaultRowValues?: (() => RowData) | RowData;
  autoFocusField?: Extract<keyof RowData, string>;
}

export const CreateTableRowButton = <RowData extends Record<string, any>>(
  props: CreateTableRowButtonProps<RowData>,
) => {
  const { t } = useTranslation();
  const {
    id = 'create-table-row',
    title = t('button.add-row'),
    onClick,
    defaultRowValues,
    autoFocusField,
    ...rest
  } = props;
  const focusField = useFocusTableRowField(autoFocusField);

  return (
    <TableOperationButton
      id={id}
      onClick={(event) => {
        onClick?.(event);
        focusField();
      }}
      title={title}
      icon={<Icon.Plus size={22} color={colorGray[7]} />}
      type="text"
      aria-label={title}
      {...rest}
    />
  );
};
